export const GET_REQUEST = 'GET';
export const POST_REQUEST = 'POST';
export const DELETE_REQUEST = 'DELETE';
export const PUT_REQUEST = 'PUT';
export const INTERNAL_SERVER_ERR_STATUS_CODE = 500;

const ERR_NO_CONNECTION = 'ERR_CONNECTION_REFUSED';

export function createHttpClient({ baseOrigin, onError, onAuthRedirect } = {}) {
    const origin = baseOrigin || `${window.location.origin}/`;

    async function invokeHTTPRequest(route, method = GET_REQUEST, bodyParams = null, qsParams = null, customHeaders = {}, customErrMsg, stream = false, abortSignal = null) {
        let response;
        try {
            response = await fetch(getURL(origin, route, qsParams), getFetchObject(method, bodyParams, customHeaders, abortSignal));
            if (stream) {
                return response;
            }
            const contentType = response.headers.get('content-type');
            if (!isValidContentType(contentType)) {
                throw new Error(`invalid response content-type ${contentType}`);
            }
            const data = await response.json();
            if (data && data.url && (response.status === 401 ||
                (route.endsWith('logout') && response.status === 200))) {
                if (onAuthRedirect) {
                    await onAuthRedirect(data, response, route);
                }
            } else if (response.status < 200 || response.status > 399) {
                throw new Error(typeof data === 'string' ? data : JSON.stringify(data));
            }
            return data;
        } catch (error) {
            error.statusCode = response ? response.status : ERR_NO_CONNECTION;
            error.name = `${error.name} ${error.statusCode}`;
            error.isError = true;
            console.error(customErrMsg || error);
            if (onError) {
                const handled = await onError(error, response, route);
                if (handled) {
                    return error;
                }
            }
            return error;
        }
    }

    return {
        GET_REQUEST,
        POST_REQUEST,
        DELETE_REQUEST,
        PUT_REQUEST,
        INTERNAL_SERVER_ERR_STATUS_CODE,
        invokeHTTPRequest,
    };
}

function isValidContentType(contentType) {
    return (contentType && (contentType.startsWith('application/json') || contentType.startsWith('application/problem+json')));
}

function getURL(origin, route, params) {
    let url = origin + route;
    if (params) {
        url += `?${new URLSearchParams(params).toString()}`;
    }
    return url;
}

function getFetchObject(method, params, customHeaders, abortSignal) {
    const fetchObj = {
        method: method,
        headers: {
            Accept: '*/*',
            ...customHeaders,
        },
    };

    if (params && method !== GET_REQUEST) {
        fetchObj.body = typeof params === 'object' ? JSON.stringify(params) : params;
    }

    if (abortSignal) {
        fetchObj.signal = abortSignal;
    }

    return fetchObj;
}
